import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { NavLinks, Link, LogoutDiv, Logout, MobileHeaderContainer, Menu, RelativeIcon, Close, StyledNavLinks, Row } from './MobileHeader.styles';

import { ReactComponent as Logo } from '../../../assets/icons/logo.svg';
import { logout } from '../../../store/slices/auth/asyncThunks';
import { useDispatch } from 'react-redux';

const navLinks = [
  {
    label: 'logistics',
    to: '/logistics?page=1',
  },
  {
    label: 'partners',
    to: '/partners?page=1',
  },
  {
    label: 'products',
    to: '/products?page=1',
  },
];
const MobileHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [openMenu, setOpenMenu] = useState(false);
  const [isVisible, setIsVisible] = useState(openMenu);

  useEffect(() => {
    let timer;
    if (openMenu) {
      timer = setTimeout(() => setIsVisible(true), 150);
    } else {
      timer = setTimeout(() => setIsVisible(false), 150);
    }

    return () => clearTimeout(timer);
  }, [openMenu]);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <MobileHeaderContainer $active={openMenu}>
      <Row>
        <Logo width={40} />
        <NavLinks>
          {navLinks.map(link => {
            return (
              <Link
                key={link.label}
                $active={
                  pathname === '/dashboard'
                    ? pathname === link.to
                    : pathname.includes('/order-details')
                    ? link.label === 'orders'
                    : pathname.includes(link.label)
                }
                onClick={() => {
                  navigate(link.to);
                }}>
                {t(link.label)}
              </Link>
            );
          })}
          <LogoutDiv onClick={handleLogout}>
            <Logout>{t('logout')}</Logout>
          </LogoutDiv>
        </NavLinks>
        {!isVisible ? (
          <RelativeIcon onClick={() => setOpenMenu(!openMenu)}>
            <Menu $active={openMenu} />
          </RelativeIcon>
        ) : (
          <RelativeIcon onClick={() => setOpenMenu(!openMenu)}>
            <Close $active={openMenu} />
          </RelativeIcon>
        )}
      </Row>

      <StyledNavLinks $active={openMenu}>
        {navLinks.map(link => {
          return (
            <Link
              key={link.label}
              $active={
                pathname === '/dashboard'
                  ? pathname === link.to
                  : pathname.includes('/order-details')
                  ? link.label === 'orders'
                  : pathname.includes(link.label)
              }
              onClick={() => {
                setOpenMenu(false);

                navigate(link.to);
              }}>
              {t(link.label)}
            </Link>
          );
        })}
        <LogoutDiv onClick={handleLogout}>
          <Logout>{t('logout')}</Logout>
        </LogoutDiv>
      </StyledNavLinks>
    </MobileHeaderContainer>
  );
};

export default MobileHeader;
